import { render, staticRenderFns } from "./discount-overview.vue?vue&type=template&id=3e08141a&"
import script from "./discount-overview.vue?vue&type=script&lang=js&"
export * from "./discount-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports